module.exports = __webpack_public_path__ + "img/Garden-Icon.8b4ab0a4.webp";